import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MarkdownModule } from 'ngx-markdown';

import { ImageComponent } from '@valk-nx/components/ui-image/src/lib/image.component';
import { PricingComponent } from '@valk-nx/components/ui-pricing/src/lib/pricing';
import { RibbonComponent } from '@valk-nx/components/ui-ribbon/src/lib/ribbon';
import { TagComponent } from '@valk-nx/components/ui-tag/src/lib/tag';
import { CardImageGridComponent } from '@valk-nx/compositions/ui-card-image-grid/src/lib/card-image-grid.component';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

import { DealCardComponent } from './deal-card.component';

@NgModule({
	declarations: [DealCardComponent],
	exports: [DealCardComponent],
	imports: [
		SVG_ICON_IMPORTS,
		CommonModule,
		MarkdownModule.forRoot({}),
		PricingComponent,
		ImageComponent,
		RibbonComponent,

		TagComponent,
		CardImageGridComponent,
		TranslateDirective,
		TranslatePipe,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DealCardModule {}
